import type { ReactNode } from 'react'

import { ApiError } from '@/lib/api/client'
import { formatApiError } from '@/lib/format-api-error'
import { m } from '@/lib/paraglide/messages'

/** Plain-Vietnamese sentence for a failed close/skip/reopen call. The server
 *  sends only a code and params; the wording lives in the frontend. */
export const resolutionErrorText = (error: unknown) =>
    formatApiError(error, m.einvoice_err_resolution_failed()).title

export const apiErrorCode = (error: unknown) =>
    error instanceof ApiError ? error.code : undefined

/** Order that already carries the typed invoice number, for the "see order" link. */
export function numberInUseOrderCode(error: unknown): string | undefined {
    if (!(error instanceof ApiError) || error.code !== 'EINVOICE_NUMBER_IN_USE')
        return undefined
    const code = error.params?.order_code
    return typeof code === 'string' && code !== '' ? code : undefined
}

export function OrderCodeLink({ orderCode }: { orderCode: string }): ReactNode {
    const query = new URLSearchParams({ q: orderCode, period: 'all' })
    return (
        <a
            href={`/orders?${query.toString()}`}
            target="_blank"
            rel="noreferrer"
            className="mt-1 inline-block text-xs text-primary underline underline-offset-2"
        >
            {m.einvoice_err_number_in_use_link()}
        </a>
    )
}

/** Form-level failure that no single field owns. */
export function ResolutionFormError({ message }: { message?: string }) {
    if (!message) return null
    return (
        <p role="alert" className="text-sm text-destructive">
            {message}
        </p>
    )
}
